export default "__VITE_ASSET__4b49037f__"